import {Html} from 'quickstart/components/content/Html'
import {Prose, Text} from 'quickstart/components/content/Text'
import {Section} from 'quickstart/components/layout/Section'
import {useMarkdown} from 'quickstart/hooks/useMarkdown'
import {ReactNode} from 'react'

type EmptyBlockProps = {
  heading?: ReactNode
} & (
  | {children?: never; message?: string | ReactNode}
  | {children?: string | ReactNode; message?: never}
)

export const EmptyBlock = ({
  heading,
  children,
  message = children,
}: EmptyBlockProps) => {
  const wrappedHeading = heading && (
    <Text variant="h1" textAlign="center">
      {heading}
    </Text>
  )

  const messageHtml = useMarkdown(typeof message === 'string' && message, {
    allowDangerousHtml: true,
  })
  const wrappedMessage =
    typeof message === 'string'
      ? messageHtml && (
          <Html variant="customer" textAlign="center" html={messageHtml} />
        )
      : message

  return (
    <Section>
      <Prose pt="4rem">
        {wrappedHeading || null}
        {wrappedMessage || null}
      </Prose>
    </Section>
  )
}
